<template>
<div>
  <CenterizedTile @click="dialog=true">
    <IconifiedTile>
      <template #icon>
        <div class="text-center display-1 primary--text my-2 font-weight-bold" v-html="label"></div>
      </template>
      <template #value>{{ value }}</template>
      <template #unit>{{ unit }}</template>
      <template #title>{{ config.name || $t(`type.${info.type}`) }}</template>
    </IconifiedTile>
  </CenterizedTile>
  <ConcentrationChartDialog v-if="dialog" v-model="dialog" :device="device" :endpoint="endpointId" :reportInterval="reportInterval" :unit="unit" :label="label" :material="material" @setting="showSettingsDialog"></ConcentrationChartDialog>
</div>
</template>

<script>
import EndpointTile from '@/components/tile/EndpointTile'
import CenterizedTile from '@/components/tile/CenterizedTile'
import IconifiedTile from '@/components/tile/IconifiedTile'
import ConcentrationChartDialog from '@/components/chart/ConcentrationChartDialog'

export default {
  name: 'ConcentrationTile',
  mixins: [EndpointTile],
  components: {
    CenterizedTile,
    IconifiedTile,
    ConcentrationChartDialog
  },
  props: {
    material: {
      type: String
    }
  },
  computed: {
    key() {
      return (this.material || 'CO2').toLowerCase();
    },
    reportUnit() {
      return this.info.configurations.reportUnit;
    },
    reportInterval() {
      return this.info.configurations.reportInterval;
    },
    label() {
      switch (this.material) {
        case 'CO':
          return 'CO';
        case 'VOC':
          return 'VOC';
        default:
          return 'CO<sub>2</sub>';
      }
    },
    value() {
      let v = this.report[this.key];
      return v ? v : '---';
    },
    unit() {
      return this.$t(`unit.${this.reportUnit}`);
    }
  }
}
</script>
